import getTransform from './getTransform.js';
export default function (enabledElement, pt) {
    const transform = getTransform(enabledElement);
    return transform.transformPoint(pt);
}
